import { ApiUtility } from "../../Utilities/ApiUtility.axios";
import { ITableRoleType } from "../Pages/Users/Users/Users";
import { isBulkActiveItemsList } from "./ItemsService";
import { UserDBRecordStatus } from "./SalesService";

export enum ApplicationRoleNames {
  SUPERADMIN,
  ADMIN,
  AUTHORITIES,
  DATAENTRY,
  AUDITORS,
  VIEWONLY,
}

export enum UserUpdateSection {
  BasicDetail,
  VoucherSetting,
  ReportSetting,
  MasterSetting,
  SettingAccess,
}

export enum Report_Type {
  BalanceSheet,
  PnL,
  TrialBalance,
  CashFlow,
  DebtorsAgeing,
  CreditorsAgeing,
  CustomerOutstanding,
  SupplierOutstanding,
  GeneralLedger,
  FAR,
  BRS,
  GST,
  TCSTDS,
  BankReconciliation,
}

export enum Report_TypeAction {
  allowToView,
  allowToPrint,
}

export enum Master_Type {
  Client,
  Ledger,
  Group,
  Item,
  ItemGroup,
  Unit,
  Asset,
}

export enum Setting_Type {
  CompanyInfo,
  Voucher,
  Report,
  OpeningEntry,
  Templates,
  DefaultLedger,
  TnC,
  Email,
  // Items,
  // TDS,
  // TCS,
  // Currencies,
}

export enum Actions {
  Authorize,
  AddOrEdit,
  Delete,
  View,
  Print,
}

export enum SelectClientsType {
  AllClients,
  SelectClients,
}

export const UserTableRoleTypeOption = [
  {
    label: "All Clients",
    value: ITableRoleType.AllClients,
  },
  {
    label: "Limited Clients",
    value: ITableRoleType.LimitedClients,
  },
  {
    label: "Client-Specific Role",
    value: ITableRoleType.ClientSpecificRole,
  },
];

class UserService {
  route = "V1/API/User";

  getUserList = (
    start: number,
    length: number,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    status?: UserDBRecordStatus,
    requestModel?: any
  ) =>
    ApiUtility.get(`${this.route}/UserList`, {
      start,
      length,
      search,
      sortCol,
      sortDir,
      status,
      requestModel,
    });

  getUserDataById = (userId: string | undefined) =>
    ApiUtility.get(`${this.route}/${userId}`);

  // postUserData = (model: any, userId: string | undefined) => {
  //   if (userId) {
  //     return ApiUtility?.post(`${this.route}/UpdateUser`, model);
  //   } else {
  //     return ApiUtility?.post(`${this.route}`, model);
  //   }
  // };

  postUserData = (model: any, userId: string | undefined) =>
    ApiUtility?.post(`${this.route}/${userId ? userId : ""}`, model);

  UpdateUserDetailsData = (
    UserId: string | undefined,
    model: any,
    UserUpdateSection: UserUpdateSection
  ) =>
    ApiUtility.post(
      `${this.route}/${UserId}?updateSection=${UserUpdateSection}`,
      model
    );

  isActiveUser = (
    userId: string,
    status?: UserDBRecordStatus,
    itemsIdList?: isBulkActiveItemsList
  ) =>
    ApiUtility.post(
      `${this.route}/IsActive?UserId=${userId}&status=${status}`,
      {
        itemsIdList,
      }
    );

  //Delete API
  deleteUser = (userId: string) => ApiUtility.delete(`${this.route}/${userId}`);

  userList = (clientId: string) =>
    ApiUtility.get(`${this.route}/ClientsUserList/${clientId}`);
}

export default new UserService();
